import BaseIdbRepository from "repositories/idb/BaseIdbRepository";
import MetaIdbRepository from "repositories/idb/MetaIdbRepository";
import { IndexedDbNames } from "services/SystemNames";

const _store: string = IndexedDbNames.MetaStore;

export class Repository {

    static async getFontStyle(id: string) {
        return await BaseIdbRepository.getAsync(_store, id);
    }

    static async setFontStyle(id: string, value: number) {
        await BaseIdbRepository.setAsync(_store, id, { id: id, value: value });
    }

    static async setPreferencesMapMiniAsync(obj:any) {
        await MetaIdbRepository.setPreferencesMapMiniAsync(obj);
    }

    static async getPreferencesMapMiniAsync() {
        return await MetaIdbRepository.getPreferencesMapMiniAsync();
    }
}
